var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row py-2" }, [
    _c(
      "div",
      {
        class: ["d-flex", "col-12"].concat(_vm.customClasses),
        staticStyle: { "flex-wrap": "wrap" },
      },
      [
        _c(
          "div",
          { staticClass: "col-md-6 col-sm-12 p-0" },
          [_vm._t("description")],
          2
        ),
        _c(
          "div",
          {
            staticClass: "col-md-6 p-0 col-sm-12 text-right",
            staticStyle: {
              display: "flex",
              "justify-content": "end",
              "align-items": "flex-end",
            },
          },
          [_vm._t("actions")],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }